import script from "./ValidMixin.vue?vue&type=script&lang=js"
export * from "./ValidMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__